import axios                                                                from "axios";
import { freezeBodyScroll, unfreezeBodyScroll, isUserLoggedIn, isUserProf } from './Utils';

export default class ProfileModals
{
    constructor ()
    {


        axios.defaults.headers.common = {
            'X-Requested-With' : 'XMLHttpRequest',
            'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
        };

        this.copydeck           = AsGlobalSettings.copydeck;
        this.userMessageOptions = AsGlobalSettings.userMessagingOptions;

        this.modal = document.querySelector( '#profile-modal' );

        this.bindEvents();
    }

    bindEvents ()
    {


        document.addEventListener( 'click', ( e ) =>
        {
            // loop parent nodes from the target to the delegation node
            for ( let target = e.target; target && target !== this; target = target.parentNode )
            {
                if ( typeof target.matches === 'function' )
                {

                    const typeOfMatch = false;

                    const isProfileLink     = target.matches( '.user-profile-popup' );
                    const isAuthorShortcode = target.matches( '[data-author-id]' );
                    const isMediaShortcode  = target.matches( '[data-media-id]' );
                    const isUsername        = target.matches( 'span.username [data-user]' );
                    const isMentioned       = target.matches( 'span.username:not([data-user])' );

                    // none of the handled scenarios
                    if ( !isProfileLink && !isAuthorShortcode && !isMediaShortcode  && !isMentioned)
                    {
                        continue; // the loop
                    }

                    e.preventDefault();

                    let type = '',
                        id   = '';

                    if ( isProfileLink )
                    {
                        type = target.dataset.userType;
                        id   = parseInt( target.dataset.userId );
                    }
                    else if ( isMentioned )
                    {
                        id = target.innerText;
                        type = "mention"
                    }

                    else if ( isAuthorShortcode )
                    {
                        type = "author";
                        id   = parseInt( target.dataset.authorId );
                    }
                    else if (isUsername)
                    {
                        id = target.innerText;
                        type = "user"
                    }
                    else
                    {
                        type = "media";
                        id   = parseInt( target.dataset.mediaId );
                    }


                    if ( type === '' || id === 0 )
                    {
                        console.error( '[ProfileModals] Element is missing some information.', target );
                        break;
                    }


                    this.handleClick( target, type, id );


                    break;
                }
            }
        }, false );
    }


    handleClick ( clicked, type, id )
    {


        this.prepModal( type, id );
        this.showModal( true );


    }


    async prepModal ( userType, userId )
    {
        // console.log( 'prepModal', userType, userId );


        this.messagingUserType = userType;

        this.modal.classList.add( 'ajaxing' );
        this.modal.classList.remove( 'user-type_author', 'user-type_user', 'user-type_author_internal', 'user-type_author_external', 'user-type_media' );
        this.modal.classList.add( 'user-type_' + userType );


        try
        {
            let response = await axios.get( `/endpoints/user-profile`, {
                params : {
                    userType : userType,
                    userId   : userId,
                },
            } );


            this.userId        = userId;
            let modalInnerHtml = response.data;


            if ( modalInnerHtml.length === 0 )
            {
                this.modal.classList.remove( 'ajaxing' );
                return;
            }

            const innerModal     = this.modal.querySelector( '.modal-inner-inner' );
            innerModal.innerHTML = modalInnerHtml;

            this.modal.classList.remove( 'ajaxing' );
            const btnSend = this.modal.querySelector( "form.messaging" );

            if ( btnSend )
            {
                btnSend.addEventListener( "submit", ( e ) => this.submitMessage( e ) )
            }
            this.modal.classList.remove( 'ajaxing' );

            const $sel    = $( innerModal ).find( 'select' );
            const $parent = $sel.parent();

            const select = $( innerModal ).find( 'select' ).select2( {
                minimumResultsForSearch : Infinity,
                width                   : 'calc(100% - 80px)',
                dropdownParent          : $parent,
            } );

            this.bindShowHideBadges();
        }

        catch (error)
        {
            this.hideModal();
            console.error( '[prepModal]', error );
        }


    }

    async submitMessage ( e )
    {
        e.preventDefault();

        if ( isUserProf() )
        {
            const triggerEvent = new Event( 'openExplanationProfs' );
            window.dispatchEvent( triggerEvent );
            return;
        }

        if ( !isUserLoggedIn() )
        {
            const triggerEvent = new Event( 'openExplanationJeunes' );
            window.dispatchEvent( triggerEvent );
            return;
        }

        const innerModal = this.modal.querySelector( '.modal-inner-inner' );
        let sel          = innerModal.querySelector( '[name="user-message-select"]' )

        let payload = {
            id_receiver : this.userId,
            id_message  : parseInt( sel.value ),
            user_type   : this.messagingUserType,
        };

        let response = await axios.post( "/endpoints/message/send", payload );

        if ( response.data.success )
        {

            let form = innerModal.querySelector( ".messaging" );
            form.remove();

            const successBlock = innerModal.querySelector( ".messaging-success" );
            if ( successBlock )
            {
                successBlock.style.display = 'block';
                successBlock.setAttribute( "aria-hidden", false );
            }
        }

    }


    showModal ( showAsAjaxing )
    {
        this.modal.style.display = 'block';


        freezeBodyScroll();

        if ( showAsAjaxing )
        {
            this.modal.classList.add( 'ajaxing' );
        }

        this.bindCloseEvents();


    }

    hideModal ()
    {

        unfreezeBodyScroll();

        this.modal.style.display = 'none';
        this.unbindCloseEvents();

        this.resetModal();
    }

     handleCloseClickBound = this.handleCloseClick.bind( this )

    bindCloseEvents ()
    {
        document.addEventListener( 'click',  this.handleCloseClickBound);
    }

    unbindCloseEvents ()
    {
        document.removeEventListener( 'click', this.handleCloseClickBound);

    }

    handleCloseClick ( event )
    {
        if ( event.target.classList.contains( 'bg' ) || event.target.classList.contains( 'btn-close' ) )
        {
            this.hideModal();
        }
    }

    resetModal ()
    {
        const innerModal     = this.modal.querySelector( '.modal-inner-inner' );
        innerModal.innerHTML = '<span class="ajax-loader centered"></span>';
    }


    bindShowHideBadges ()
    {

        this.btnBadgesToggle = this.modal.querySelector( '.link-show-all' );
        this.badgesOpen      = false;

        this.allOtherBadgesContainer = this.modal.querySelector( '.all-other-badges' );

        if ( !this.allOtherBadgesContainer )
        {
            return;
        }

        this.otherBadges = this.allOtherBadgesContainer.querySelectorAll( '.badge' );
        if ( !this.otherBadges )
        {
            // nothing to actually toggle
            return;
        }

        this.btnBadgesToggle.addEventListener( 'click', ( e ) =>
        {
            if ( this.badgesOpen )
            {
                this.hideBadges();
            } else
            {
                this.showBadges();
            }
        } )

    }


    showBadges ()
    {
        this.allOtherBadgesContainer.classList.add( 'open' );
        this.btnBadgesToggle.classList.add( 'open' );
        this.allOtherBadgesContainer.setAttribute( 'aria-expanded', true );
        this.badgesOpen = true;
    }

    hideBadges ()
    {

        this.allOtherBadgesContainer.classList.remove( 'open' );
        this.btnBadgesToggle.classList.remove( 'open' );
        this.allOtherBadgesContainer.setAttribute( 'aria-expanded', false );
        this.badgesOpen = false;
    }

}
